import React, { useEffect } from "react";
import fullpage from "fullpage.js";
import MainSecTwo from "../components/templates/MainSecTwo/MainSecTwo";
import MainSecThree from "../components/templates/MainSecThree/MainSecThree";
import MainSecFour from "../components/templates/MainSecFour/MainSecFour";
import MainSecFiveMobile from "../components/templates/MainSecFive/MainSecFiveMobile";

/**
 * MainPage component that sets up a full-page scrolling interface using fullPage.js.
 *
 * @component
 * @returns {JSX.Element} The rendered MainPage component.
 */

export default function MainPage() {
  // Initialize fullPage.js with specified options
  useEffect(() => {
    new fullpage("#fullPage", {
      licenseKey: "license here", // Speed of scrolling between sections
      scrollingSpeed: 1000,
      verticalCentered: false, // Disable vertical centering of content
      anchors: ["section1", "section2", "section3", "section4"], // Define anchors for sections
      credits: {
        enabled: false, // Disable credits
        label: "Made with fullPage.js", // Credit label
        position: "right", // Position of the credit label
      },
      afterLoad: function (origin, destination, direction) {},
    });
  }, []);

  return (
    <>
      <div id="fullPage">
        <div className="section bg-color-primary-A">
          <MainSecTwo /> {/* Main section two component */}
        </div>
        <div className="section bg-color-primary-A">
          <MainSecThree /> {/* Main section three component */}
        </div>
        <div className="section bg-color-primary-A">
          <MainSecFour /> {/* Main section four component */}
        </div>
        {window?.innerWidth < 769 && (
          <div className="section   bg-color-primary-A">
            <MainSecFiveMobile /> {/* Main section five for mobile devices */}
          </div>
        )}
      </div>

      {/* Include the fullPage.js stylesheet */}
      <link
        rel="stylesheet"
        href="https://cdnjs.cloudflare.com/ajax/libs/fullPage.js/4.0.10/fullpage.css"
        integrity="sha512-t+t6zJIt91gRlTfGo/bOo34WpqUOYwGuPmMtOb7XHPCjGJXMtkCzenfNh5t+dBVChlvjMEa26jZsq85zcXVcRQ=="
        crossorigin="anonymous"
        referrerpolicy="no-referrer"
      />

      {/* Include the fullPage.js script */}
      <script
        src="https://cdnjs.cloudflare.com/ajax/libs/fullPage.js/4.0.10/fullpage.js"
        integrity="sha512-5Kp21g+Nh8kPxSiYx6V8DZEhMfw1lnFmI4trArKux2Z/4738SyB4j3F9H89s0w9jsX4M1C29QFvqA+l55rK8aw=="
        crossorigin="anonymous"
        referrerpolicy="no-referrer"
      ></script>
    </>
  );
}
